import { useQuery } from "@apollo/react-hooks";
import { GET_SPENDING_MONTHS } from "../api/spending";
import getTimezoneOffset from "../utils/timezone";

// 花費紀錄快轉 outliner 用：全歷史每月筆數索引。
// 新增/刪除花費會改變月份集合與筆數，呼叫端須在 mutation 完成後以 refetch 更新索引。
export default () => {
  const { data, loading, refetch } = useQuery(GET_SPENDING_MONTHS, {
    variables: { timezoneOffset: getTimezoneOffset() },
  });

  return {
    months: (data && data.spendingMonths) || [],
    loading,
    refetch,
  };
};
